import * as React from 'react';
import { Modal } from 'antd';
import './Store.less';
import { EditIcon, EntityCard } from '@ui/components';
import storePng from '@ui/assets/store.png';
import { getApiUrl } from '../../../../utils/config';

interface Props {
  store: any;
  removeStore: (storeId: string) => void;
  editStore: (values: any) => void;
}

class Store extends React.PureComponent<Props> {
  state = {
    isOpenRemove: false,
  };

  handleChangeRemoveState = (isOpenRemove: boolean) => {
    this.setState({ isOpenRemove });
  };

  handleRemoveStore = () => {
    const {
      store: { id },
      removeStore,
    } = this.props;

    this.handleChangeRemoveState(false);
    removeStore(id);
  };

  render() {
    const {
      store: {
        id,
        name,
        address,
        phone,
        firstName,
        lastName,
        firstContactPhone,
        secondContactPhone,
        photo,
      },
      editStore,
    } = this.props;

    const { isOpenRemove } = this.state;
    return (
      <EntityCard>
        <div className="store-card">
          <div className="store-card-panel">
            <div className="store-card-panel__photo">
              {photo ? (
                <img
                  className="store-card-image"
                  src={`${getApiUrl()}/store/${id}/get-photo`}
                  alt=""
                />
              ) : (
                <img className="store-card-image" src={storePng} alt="" />
              )}
            </div>
            <div className="store-card-panel__info">
              <div className="store-card-panel__info__name">{name}</div>
              <div className="store-card-panel__info__address">{address}</div>
              <div className="store-card-panel__info__phone">
                <a href={`tel:${phone}`}>{phone}</a>
              </div>
            </div>
            <div className="store-card-panel__contact">
              <div className="store-card-panel__contact__name">
                <span>{firstName}</span>
                <span>{lastName}</span>
              </div>
              <div className="store-card-panel__contact__phone">
                <a href={`tel:${firstContactPhone}`}>{firstContactPhone}</a>
                <a href={`tel:${secondContactPhone}`}>{secondContactPhone}</a>
              </div>
            </div>
          </div>
          <div className="store-card-edit">
            <EditIcon type="edit" onClick={() => editStore(id)} />
            <EditIcon
              type="remove"
              onClick={() => this.handleChangeRemoveState(true)}
            />
          </div>
          <Modal
            okButtonProps={{
              style: {
                width: '120px',
              },
              size: 'large',
              type: 'danger',
            }}
            cancelButtonProps={{
              style: {
                width: '120px',
              },
              size: 'large',
              type: 'primary',
            }}
            okText="Да"
            cancelText="Нет"
            title="удаление магазина"
            visible={isOpenRemove}
            onOk={this.handleRemoveStore}
            onCancel={() => this.handleChangeRemoveState(false)}
          >
            <p>Вы уверены, что ходите удалить?</p>
            <p>Магазин</p>
            <p style={{ fontSize: '16px' }}>{name}</p>
          </Modal>
        </div>
      </EntityCard>
    );
  }
}

export default Store;



// WEBPACK FOOTER //
// ./src/scenes/Stores/components/Store/Store.tsx